import React, { Component, Fragment } from 'react';
import { PulseLoader, BarLoader } from 'react-spinners';
import axios from 'axios';
import EventItem from './EventItem';
import EventFilter from './EventFilter';

const API_URL = process.env.REACT_APP_API_URL+'api/events';
const ORG_API_URL = process.env.REACT_APP_API_URL+'api/organisations';
const INITIAL_STATE = {
	events: [],
	next_page: API_URL,
	loading: false,
	init_load_more: false,
	pagination: [],
	event: {
		title: '',
		type: 0,
		organisation_title: '',
		artsmark_partner: 0,
		support_send: 0,
		keystages: [],
		artform: 0,
		venue_name: '',
		postcode: '',
		status: 'active',
		sort: 'title',
		page: 1
	}
};

class EventSearchList extends Component {
	state = INITIAL_STATE;

	componentDidMount() {
		this.eventFilter = React.createRef();
		
		if (this.props.id && !this.state.loading) {

			this.setState({
				loading: true
			});

			axios.get(ORG_API_URL+'/'+this.props.id)
				.then(response => {
					let orgTitle = response.data.data.title;

					this.setState(
						prevState => ({
							event: {
								organisation_title: orgTitle,
								visible: 1,
								status: 'active'
							},
							loading: false,
						}), () => console.log(this.state)
					);

					this.getFilteredResults();
				});
		} else {
			this.init();
		}
	}

	init() {
		if(!this.state.loading) {
			this.setState({
				loading: true
			});

			axios.get(this.state.next_page)
				.then(response => {
					const paginator = response.data.meta.pagination;
					const events = response.data.data;

					if(events.length){
						this.setState({
							events: [...this.state.events, ...events],
							next_page: paginator.links.next,
							loading: false
						});					
					}

					if(paginator.links.next){
						this.setState({ init_load_more: true });
					}
				});
		}
	}

	onClearFilter = () => {
		this.setState(INITIAL_STATE, () => {
			this.init();
			this.eventFilter.current.getArtformTypes();
		});
	};

	onFilteredResults = (props) => {
		this.setState({
			events: [],
			init_load_more: false,
			event: {
				title: props.event.title,
				type: props.event.type,
				organisation_title: props.event.organisation_title,
				support_send: props.event.support_send,
				keystages: props.event.keystages,
				postcode: props.event.postcode,
				artform: props.event.artform,
				sort: props.event.sort,
				status: props.event.status,
				page: props.page,				
			}
		}, () => this.getFilteredResults()
		);
	}

	getFilteredResults = () => {
		console.log(this.state);

		axios.post(API_URL+'/filter', {
			title: this.state.event.title,
			type: this.state.event.type,
			organisation_title: this.state.event.organisation_title,
			support_send: this.state.event.support_send,
			keystages: this.state.event.keystages,
			postcode: this.state.event.postcode,
			artform: this.state.event.artform,
			sort: this.state.event.sort,
			status: this.state.event.status,
			page: this.state.event.page,
			visible: this.state.event.visible
		})
		.then(response => {
			const events = response.data.data;
			const pagination = response.data.meta.pagination;

			console.log(events);

			if (this.state.pagination.total_pages > this.state.pagination.current_page) {
				this.setState({
					events: [...this.state.events, ...events],
					loading: false,
					pagination: pagination,
				});
			} else {
				this.setState({
					events: events,
					loading: false,
					pagination: pagination,
				});				
			}
		});
	};

	onLoadMore = () => {
		if (this.state.pagination.total_pages >= this.state.pagination.current_page) {
			this.setState(
				prevState => ({
					event: {
						...prevState.event,
						page: this.state.event.page + 1					
					}
				}), () => this.getFilteredResults()
			);
		}

		if (this.state.init_load_more) {
			this.init();
		}
	};

	renderLoadmore() {
		if (this.state.pagination.total_pages > this.state.pagination.current_page || this.state.init_load_more) {
			return (
				<div className="container">
					<div className="d-flex justify-content-center align-items-center py-4">						
						<button onClick={this.onLoadMore} className="btn btn-primary btn-lg">
							Load More <div className="loading-spinner">
							<BarLoader
								color={'#FFF'}
								loading={this.state.loading}
							/>
						</div></button>
					</div>
				</div>
			);	
		}
	};

	renderResults() {
		if (this.state.events.length) {
			return (
				this.state.events.map(event => 
					<EventItem key={event.id} event={event}/>
				)
			);
		}

		if (!this.state.loading) {
			return (
				<div className="container">
					<div className="d-flex justify-content-center align-items-center py-4">
						<h1>No results found</h1>
					</div>
				</div>
			);			
		}
	}

	renderLoadStatus() {
		if (this.state.loading) {
			return (
				<div className="container">
					<div className="d-flex justify-content-center align-items-center py-4">
						<div className="loading-spinner">
							<PulseLoader
								color={'#28A2FB'}
								loading={this.state.loading}
							/>
						</div>
					</div>
				</div>
			);
		}
	}

	render() {
		return (
			<Fragment>
				<EventFilter 
					ref={this.eventFilter}
					onClearFilter={this.onClearFilter} 
					onFilteredResults={this.onFilteredResults}
				/>

				<section id="tabResults" className="tab-results">
					{ this.renderResults() }
					{ this.renderLoadmore() }
					{ this.renderLoadStatus() }
				</section>
			</Fragment>
		)
	}
}

export default EventSearchList;